import React from "react";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";

const MultiLocationActivityChart = ({ podiumSnapshots = [], selectedDate }) => {
    if (!Array.isArray(podiumSnapshots) || podiumSnapshots.length === 0) {
        return null;
    }

    const totals = podiumSnapshots.reduce(
        (acc, row) => {
            acc.active += Number(row?.snapshot?.activeOnDate || 0);
            acc.completed += Number(row?.snapshot?.checkedOutOnDate || 0);
            acc.total += Number(row?.snapshot?.activeOnDate || 0) + Number(row?.snapshot?.checkedOutOnDate || 0);
            return acc;
        },
        { active: 0, completed: 0, total: 0 },
    );

    const chartData = podiumSnapshots.map((row) => ({
        podiumName: row?.podium?.name || "Podium",
        Active: Number(row?.snapshot?.activeOnDate || 0),
        Completed: Number(row?.snapshot?.checkedOutOnDate || 0),
    }));

    return (
        <div className="dashboard-multi-chart-box">
            <div className="dashboard-multi-chart-title">Multi-Location Podium Activity ({selectedDate || "Today"})</div>

            <div className="dashboard-multi-chart-kpis">
                <span className="dashboard-multi-chart-kpi">Active: {totals.active}</span>
                <span className="dashboard-multi-chart-kpi">Completed: {totals.completed}</span>
                <span className="dashboard-multi-chart-kpi dashboard-multi-chart-kpi-total">Total: {totals.total}</span>
            </div>

            <div className="dashboard-multi-chart-wrap">
                <ResponsiveContainer
                    width="100%"
                    height={300}>
                    <BarChart
                        data={chartData}
                        margin={{ top: 8, right: 10, left: 0, bottom: 40 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="podiumName"
                            interval={0}
                            angle={0}
                            textAnchor="middle"
                            height={58}
                        />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Bar
                            dataKey="Active"
                            stackId="total"
                            fill="#0697f7"
                        />
                        <Bar
                            dataKey="Completed"
                            stackId="total"
                            fill="#93B249"
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default MultiLocationActivityChart;
